'use client';

import { useLocationContext } from 'mode-shared/context/LocationContext';
import { Button, PocketbookIcon } from 'mode-shared/components';
import { useConnectionStatus } from 'mode-shared/hooks/wallet/useConnectionStatus';
import { WalletDropdown } from 'mode-shared/components';
import { usePrivy } from 'mode-shared/context/WalletConnectorContext';

export const ConnectButton = () => {
  useConnectionStatus();
  const { isReadOnly } = useLocationContext();
  const { login, authenticated } = usePrivy();

  if (authenticated) {
    return <WalletDropdown />;
  }

  return (
    <Button disabled={isReadOnly} onClick={login}>
      <span className="hidden md:inline">Connect</span>
      <PocketbookIcon className="md:ml-2 text-neutral-black" />
    </Button>
  );
};
